import React from 'react'

const normalizeBillToLabel = billTo => {
  const normalized = String(billTo || '')
    .trim()
    .toLowerCase()

  if (['parent', 'parent-pay', 'parent pay'].includes(normalized)) {
    return 'Parent Pay'
  }

  if (['self', 'child', 'self-pay', 'self pay'].includes(normalized)) {
    return 'Self Pay'
  }

  return String(billTo || '').trim()
}

function AccountInfoBanner({
  thryvId,
  companyName,
  firstName,
  lastName,
  billTo,
  style,
}) {
  const displayName =
    companyName || [firstName, lastName].filter(Boolean).join(' ')
  const billToLabel = normalizeBillToLabel(billTo)
  if (!thryvId && !displayName && !billToLabel) return null

  return (
    <div
      style={{
        backgroundColor: '#F4F6FB',
        borderRadius: '3px',
        padding: '10px',
        width: '100%',
        ...style,
      }}
    >
      <div style={{paddingLeft: '10px'}}>
        {displayName && (
          <h6
            className="font-montserrat font-semibold text-thryv-black-500"
            style={{margin: thryvId || billToLabel ? '0 0 2px' : 0}}
          >
            {displayName}
          </h6>
        )}
        {thryvId && (
          <p
            className="font-montserrat text-thryv-black-500"
            style={{margin: 0, fontSize: '13px', fontWeight: '400'}}
          >
            {thryvId}
          </p>
        )}
        {billToLabel && (
          <p
            className="font-montserrat text-thryv-black-500"
            style={{margin: 0, fontSize: '13px', fontWeight: '400'}}
          >
            <span style={{fontWeight: '600'}}>Bill to:</span> {billToLabel}
          </p>
        )}
      </div>
    </div>
  )
}

export {AccountInfoBanner, normalizeBillToLabel}
